<template>
  <div class="mevents-player">
    <div class="mevents-player__element">
      <div :id="newPlayerId" class="meventsPlayerElement" />
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
import axios from "axios";
import utils from "../utilities";
import EventBus from "~/states/event-bus";

export default {
  name: "MEventsPlayer",
  data() {
    return {
      divisor: 25, // percent buckets ( 25%-75% )
      videos_status: {},
      videos: null,
      duration: -60,
      lastSync: new Date(),
      playbackid: null,
      videoid: null,
      trackingstatus: "",
    };
  },
  inject: {
    TrackingUtil: {
      type: Function,
    },
  },
  props: {
    playerObject: {
      type: Object,
      required: true,
    },
    iscarousel: {
      type: Boolean,
      default: false,
    },
    autoplay: {
      type: Boolean,
      default: true,
    },
    newPlayerId: {
      type: String,
      default: 'meventsPlayerElement',
    },
    sessionId: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters({
      user: "user/user",
      configForKey: "config/configForKey",
    }),
    appConfig() {
      const appConfig = this.configForKey("app_config");
      if (appConfig) {
        return appConfig.config[0];
      }
      return null;
    },
    virtualMeetingUrl() {
      return this.appConfig ? this.appConfig.VirtualMeetingUrl : null;
    },
  },
  async mounted() {

    await this.loadAllScript();
  },
  beforeDestroy() {


    if (window[`mPlayer${this.sessionId}`] && !this.iscarousel) {
      window[`mPlayer${this.sessionId}`].kill();
    }
  },
  async activated() {
    await this.loadAllScript();
  },
  deactivated() {
    if (window[`mPlayer${this.sessionId}`] && !this.iscarousel) {
      window[`mPlayer${this.sessionId}`].kill();
    }
  },
  watch: {
    playerObject() {
      if (window[`mPlayer${this.sessionId}`]) {
        window[`mPlayer${this.sessionId}`].kill();
      }
      setTimeout(() => {
        window[`mPlayer${this.sessionId}`] = window
          .$(`#${this.newPlayerId}`)
          .mEventsPlayer(this.playerObject);

        if (
          this.playerObject.sessionRecording && 
          this.playerObject.exporttype === "autoFolder"
        ) {
          setTimeout(() => {
            const jumptimes = window[`mPlayer${this.sessionId}`].getAllChapters();
            this.addJumptimes(jumptimes)
          }, 1500);
        }
      }, 500);
    },
  },
  methods: {
    ...mapActions({
      addJumptimes: "sessionRecordingData/addJumptimes",
    }),
    tracking(event, elementSrc) {
      if (utils.advancedTracking() && this.user?.UserId) {
        this.TrackingUtil.trackEvent(
          "HTML5 Video",
          event,
          utils.advancedTrackingFormat(
            this.user.UserId,
            "Page",
            "Video",
            elementSrc
          )
        );
      }
    },
    checkScript(script) {
      return !$(`script[src='${script}']`).length > 0
    },  
    async loadAllScript() {
      if(this.checkScript('https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.19/lodash.js')) {
        await this.$loadScript(
          "https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.19/lodash.js"
        );
      }

      if(this.checkScript('https://d2t0unnjxes6lt.cloudfront.net/data/player/assets/backbone-min.js')) {
        await this.$loadScript(
          "https://d2t0unnjxes6lt.cloudfront.net/data/player/assets/backbone-min.js"
        );
      }

      if(this.checkScript('https://d2t0unnjxes6lt.cloudfront.net/data/player/assets/openseadragon.js')) {
        await this.$loadScript(
          "https://d2t0unnjxes6lt.cloudfront.net/data/player/assets/openseadragon.js"
        );
      }

      if(this.checkScript('https://d2t0unnjxes6lt.cloudfront.net/data/player/assets/video.7.7.4.min.js')) {
        await this.$loadScript(
          "https://d2t0unnjxes6lt.cloudfront.net/data/player/assets/video.7.7.4.min.js"
        );
      }

      if(this.checkScript('https://d2t0unnjxes6lt.cloudfront.net/data/player/assets/videojs-http-streaming.min.js')) {
        await this.$loadScript(
          "https://d2t0unnjxes6lt.cloudfront.net/data/player/assets/videojs-http-streaming.min.js"
        );
      }

      if(this.checkScript('https://d2t0unnjxes6lt.cloudfront.net/data/player/assets/videojs-vr.min.js')) {
        await this.$loadScript(
          "https://d2t0unnjxes6lt.cloudfront.net/data/player/assets/videojs-vr.min.js"
        );
      }

      if(this.checkScript('https://player.live-video.net/1.5.0/amazon-ivs-videojs-tech.min.js')) {
        await this.$loadScript(
          "https://player.live-video.net/1.5.0/amazon-ivs-videojs-tech.min.js"
        );
      }

      if(this.checkScript('https://player.live-video.net/1.5.0/amazon-ivs-quality-plugin.min.js')) {
        await this.$loadScript(
          "https://player.live-video.net/1.5.0/amazon-ivs-quality-plugin.min.js"
        );
      }

      if(this.checkScript('https://d2t0unnjxes6lt.cloudfront.net/data/player/assets/three.js')) {
        await this.$loadScript(
          "https://d2t0unnjxes6lt.cloudfront.net/data/player/assets/three.js"
        );
      }

      if(this.checkScript('https://d2t0unnjxes6lt.cloudfront.net/data/player/assets/videojs-panorama.min.js')) {
        await this.$loadScript(
          "https://d2t0unnjxes6lt.cloudfront.net/data/player/assets/videojs-panorama.min.js"
        );
      }

      if(this.checkScript('https://d2t0unnjxes6lt.cloudfront.net/data/player/assets/tracking-1.0.5.js')) {
        await this.$loadScript(
          "https://d2t0unnjxes6lt.cloudfront.net/data/player/assets/tracking-1.0.5.js"
        );
      }

      if(this.checkScript('https://d2t0unnjxes6lt.cloudfront.net/globals/html5player/prod/built.js')) {
        await this.$loadScript(
          "https://d2t0unnjxes6lt.cloudfront.net/globals/html5player/prod/built.js"
        );
      }

      await this.loadStylesheet(
        "https://d2t0unnjxes6lt.cloudfront.net/data/player/assets/video-js.7.7.4.css"
      );
      await this.loadStylesheet(
        "https://d2t0unnjxes6lt.cloudfront.net/data/player/assets/videojs-vr.css"
      );

      await this.loadStylesheet(
        "https://d2t0unnjxes6lt.cloudfront.net/globals/html5player/prod/style.css"
      );

      await this.loadStylesheet("https://unpkg.com/swiper/swiper-bundle.css");

      await this.loadStylesheet(
        "https://unpkg.com/swiper/swiper-bundle.min.css"
      );

      await this.loadStylesheet(
        "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.14.0/css/all.min.css"
      );

      this.initializePlayer();
    },
    initializePlayer() {


      if (this.playerObject) {
        setTimeout(() => {
          window[`mPlayer${this.sessionId}`] = window
          .$(`#${this.newPlayerId}`)
          .mEventsPlayer(this.playerObject);
        }, 100);


        if (
          this.playerObject.sessionRecording &&
          this.playerObject.exporttype === "autoFolder"
        ) {

          setTimeout(() => {
            const jumptimes = window[`mPlayer${this.sessionId}`].getAllChapters();
            this.addJumptimes(jumptimes)
          }, 1500);
        }

        this.videoid = this.playerObject.id;
        if (this.autoplay) {
          setTimeout(() => {
            window[`mPlayer${this.sessionId}`].play();
          }, 1500);
        }
      }
      this.averageDurationVideoTrackingInit();

      setTimeout(() => {
        this.videos = document.getElementsByTagName("video");

        if (this.videos[0]) {
          // TODO: check if for is really needed
          for (let i = 0; i < this.videos.length; i += 1) {
            // In order to have some id to reference in our status object,
            // we are adding an id to the video objects
            // that don't have an id attribute.
            let videoTagId;
            if (!this.videos[i].getAttribute("id")) {
              // Generate a random alphanumeric string to use is as the id
              videoTagId = `html5_video_${Math.random().toString(36).slice(2)}`;
              this.videos[i].setAttribute("id", videoTagId);
            } else {
              // Current video has alredy a id attribute, then let's use it
              videoTagId = this.videos[i].getAttribute("id");
            }
            // Video Status Object declaration
            this.videos_status[videoTagId] = {};
            // save the highest percent mark played by the user in the current video.
            this.videos_status[videoTagId].greatest_marker = 0;
            // set the progress markers, so we can know afterwards which ones have been already sent.
            this.videos_status[videoTagId]._progress_markers = {};
            for (let j = 0; j < 100; j += 1) {
              // TODO: check if for is really needed
              this.videos_status[videoTagId].progress_point =
                this.divisor * Math.floor(j / this.divisor);
              this.videos_status[videoTagId]._progress_markers[
                this.videos_status[videoTagId].progress_point
              ] = false;
            }
            // On page DOM, all players currentTime is 0
            this.videos_status[videoTagId].current = 0;
            //  setting the event listeners.
            this.videos[i].addEventListener("play", this.eventHandler, false);
            this.videos[i].addEventListener("pause", this.eventHandler, false);
            this.videos[i].addEventListener("ended", this.eventHandler, false);
            this.videos[i].addEventListener(
              "timeupdate",
              this.eventHandler,
              false
            );
          }
        } else if (
          document.getElementsByClassName(
            "mEventsPlayer-container-eposter"
          )[0] ||
          document.getElementsByClassName("mEventsPlayer-container-poster")[0]
        ) {
          const duration = 60000;
          this.trackingstatus = "start";
          this.averageDurationVideoTrackingDuration();
          setTimeout(() => {
            EventBus.$emit("videoEnded", true);
          }, duration);
        } else {
          document
            .getElementsByClassName("mEventsPlayer-play")[0]
            .addEventListener("click", this.posterPlayEventHandler, false);
          document
            .getElementsByClassName("mEventsPlayer-pause")[0]
            .addEventListener("click", this.posterPauseEventHandler, false);
          const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutationRecord) => {
              const el = document.getElementsByClassName(
                "mEventsPlayer-progressbar-actual"
              );
              this.posterDurationHandler(el[0].style.width);
            });
          });
          const target = document.getElementsByClassName(
            "mEventsPlayer-progressbar-actual"
          )[0];
          observer.observe(target, {
            attributes: true,
            attributeFilter: ["style"],
            childList: true,
            characterData: true,
          });
        }
      }, 1500);
    },
    loadStylesheet(url) {
      const ss = document.styleSheets;
      for (let i = 0, max = ss.length; i < max; i += 1) {
        if (ss[i].href === url) {
          return;
        }
      }
      const link = document.createElement("link");
      link.setAttribute("rel", "stylesheet");
      link.setAttribute("href", url);
      document.head.appendChild(link);
    },
    eventHandler(e) {
      // This is the funcion that is gonna handle the event sent by the player listeners
      // This event type is sent everytime the player updated it's current time,
      // We're using for the % of the video played.
      if (e.type === "timeupdate") {
        // Let's set the save the current player's video time in our status object
        this.videos_status[e.target.id].current = Math.round(
          e.target.currentTime
        );
        // We just want to send the percent events once
        const pct = Math.floor(
          (100 * this.videos_status[e.target.id].current) / e.target.duration
        );
        // TODO: check if for is really needed
        for (const j in this.videos_status[e.target.id]._progress_markers) {
          if (pct >= j && j > this.videos_status[e.target.id].greatest_marker) {
            this.videos_status[e.target.id].greatest_marker = j;
          }
        }
        // current bucket hasn't been already sent to GA?, let's push it to GTM
        if (
          this.videos_status[e.target.id].greatest_marker &&
          !this.videos_status[e.target.id]._progress_markers[
            this.videos_status[e.target.id].greatest_marker
          ]
        ) {
          this.videos_status[e.target.id]._progress_markers[
            this.videos_status[e.target.id].greatest_marker
          ] = true;
          this.tracking(
            `${this.videos_status[e.target.id].greatest_marker}%`,
            decodeURIComponent(e.target.currentSrc)
          );
        }
      } else if (e.type === "play") {
        this.trackingstatus = "start";
        this.tracking("Played video", decodeURIComponent(e.target.currentSrc));
        this.averageDurationVideoTrackingDuration();
      } else if (e.type === "pause") {
        this.trackingstatus = "stop";
        this.tracking("Paused video", decodeURIComponent(e.target.currentSrc));
      } else if (e.type === "ended") {
        this.trackingstatus = "stop";
        EventBus.$emit("videoEnded", true);

        // If the user ends playing the video, an Finish video will be pushed
        // ( This equals to % played = 100 )
        this.tracking("100%", decodeURIComponent(e.target.currentSrc));
      }
    },
    posterPlayEventHandler(e) {
      switch (e.type) {
        case "click":
          this.trackingstatus = "start";
          this.averageDurationVideoTrackingDuration();
          break;
        default:
          break;
      }
    },
    posterPauseEventHandler(e) {
      switch (e.type) {
        case "click":
          this.trackingstatus = "stop";
          break;
        default:
          break;
      }
    },
    posterDurationHandler(params) {
      switch (params) {
        case "25%":
          break;
        case "50%":
          break;
        case "75%":
          break;
        case "100%":
          this.trackingstatus = "stop";
          setTimeout(() => {
            EventBus.$emit("videoEnded", true);
          }, 1000);
          break;
        default:
          break;
      }
    },

    // optional :resource_id, type: Integer, desc: "Resource ID"
    // optional :resource_manage_id,type: Integer, desc: "Resource Manage ID"

    // optional :contentsession_id, type: Integer, desc: "Contentession ID"
    // optional :contentsession_manage_id, type: Integer, desc: "Contentession Manage ID"

    // optional JMT ID SPLITSYSTEM

    async averageDurationVideoTrackingInit() {
      let sessionId = null;
      if (this.user?.UserId && this.videoid) {
        const headers = {
          Authorization: `Basic ${btoa("m-events:kims")}`,
        };
        if (
          this.$route.name === "IndustryLandingPageProfile" ||
          this.$route.name === "ProfilePage"
        ) {
          sessionId = "companyprofile";
        }
        const params = this.playerObject.sessionRecording
          ? {
              [this.playerObject.teaser
                ? "presentation_manage_id"
                : "contentsession_manage_id"]: this.videoid,
              user_id: Vue.$cookies.get("user_id"),
              event_id: Vue.$cookies.get("event_id"),
              session_id: this.playerObject.teaser ? "teaser" : "recording",
            }
          : {
              resource_id: this.videoid,
              user_id: Vue.$cookies.get("user_id"),
              session_id: sessionId,
              event_id: Vue.$cookies.get("event_id"),
            };
        const config = {
          method: "post",
          url: `${this.virtualMeetingUrl}/v1/playbacks.json`,
          headers,
          params,
        };
        const response = await axios(config)
          .then((result) => {
            this.playbackid = result.data.id;
          })
          .catch((error) => console.log(error));
        return response;
      }
      return true;
    },
    averageDurationVideoTrackingDuration() {
      const now = new Date().getTime();
      let differenceMs = now - this.lastSync.getTime();
      differenceMs /= 1000;
      if (this.user?.UserId) {
        this.duration += 60;
        if (this.duration > 0 && differenceMs > 59) {
          this.lastSync = new Date();
          const headers = {
            Authorization: `Basic ${btoa("m-events:kims")}`,
          };
          const config = {
            method: "put",
            url: `${this.virtualMeetingUrl}/v1/playbacks/${this.playbackid}.json?duration_seconds=${this.duration}`,
            headers,
          };
          axios(config)
            .then((result) => result.data)
            .catch((error) => console.log(error));
        }
        if (this.trackingstatus === "start") {
          setTimeout(() => {
            this.averageDurationVideoTrackingDuration();
          }, 60000);
        }
      }
      return differenceMs;
    },
  },
};
</script>

<style lang="scss">
.meventsPlayerElement {
  height: 100%;
}
.mevents-player {
  display: block;
  position: relative;
  padding: 0;
  margin: 0;
  width: 100%;
  padding-top: 56.25%;
}

.mevents-player__element {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: calc(100% + 40.6px);
}

.player-container {
  .mEventsPlayer-controls-ads,
  .mEventsPlayer-controls {
    background: #000 !important;
  }
}

.video-js {
  background-color: #fff;
}

#meventsPlayerElement > div > div.mEventsPlayer-mainPlayerDiv > div > div.mEventsPlayer-player > div.mEventsPlayer-main > div:nth-child(1) > div.mEventsPlayer-slide-container-relative > img {
  max-width: unset !important;
}
</style>
